import { Component, inject, signal } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hero-swap',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hero-swap.component.html'
})
export class HeroSwapComponent {
  public state = inject(AppStateService);

  // Mouse tilt animation signals
  translateX = signal<number>(0);
  translateY = signal<number>(0);
  rotateX = signal<number>(0);
  rotateY = signal<number>(0);

  onMouseMove(event: MouseEvent) {
    const container = event.currentTarget as HTMLElement;
    const rect = container.getBoundingClientRect();
    const x = event.clientX - rect.left - rect.width / 2;
    const y = event.clientY - rect.top - rect.height / 2;
    
    const factorX = x / (rect.width / 2);
    const factorY = y / (rect.height / 2);
    
    this.translateX.set(factorX * 22);
    this.translateY.set(factorY * 22);
    this.rotateY.set(factorX * 12);
    this.rotateX.set(-factorY * 12);
  }

  onMouseLeave() {
    this.translateX.set(0);
    this.translateY.set(0);
    this.rotateX.set(0);
    this.rotateY.set(0);
  }
}
